<template>
    <div class="image-zoom" @touchstart="start" @touchmove="move" ref="matrixBox" @touchend="end" :style="zoomStyle">
        <sd-img :src="src" safe/>
    </div>
</template>

<script>
export default {
    name: "image-zoom",
    props: {
        src: String,
        zoomStyle: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            displacement: {
                scale: 1,
            },
            top: 0,
            left: 0,
        }
    },

    computed: {
        matrixBox() {
            let matrixBox = this.$refs.matrixBox;
            if(matrixBox.length) matrixBox=matrixBox[0];
            return matrixBox
        }
    },

    methods: {
        start(event) {
            var touches = event.touches;
            var events = touches[0];
            var events2 = touches[1];

            // event.preventDefault();

            // 第一个触摸点的坐标
            this.displacement.pageX = events.pageX;
            this.displacement.pageY = events.pageY;

            this.displacement.moveable = true;

            if (events2) {
                this.displacement.pageX2 = events2.pageX;
                this.displacement.pageY2 = events2.pageY;
            }

            this.displacement.originScale = this.displacement.scale || 1;
        },

        move(event) {
            if (!this.displacement.moveable) return;

            event.preventDefault();

            var touches = event.touches;
            var events = touches[0];
            var events2 = touches[1];

            // 双指移动
            if (events2) {
                // 第2个指头坐标在touchmove时候获取
                if (!this.displacement.pageX2) {
                    this.displacement.pageX2 = events2.pageX;
                }
                if (!this.displacement.pageY2) {
                    this.displacement.pageY2 = events2.pageY;
                }

                // 双指缩放比例计算
                var zoom = this.getDistance({
                    x: events.pageX,
                    y: events.pageY
                },{
                    x: events2.pageX,
                    y: events2.pageY
                }) / this.getDistance({
                    x: this.displacement.pageX,
                    y: this.displacement.pageY
                },{
                    x: this.displacement.pageX2,
                    y: this.displacement.pageY2
                });
                // 应用在元素上的缩放比例
                var newScale = this.displacement.originScale * zoom;
                // 最大缩放比例限制
                if (newScale > 10) {
                    newScale = 10;
                } else if (newScale < 1) {
                    newScale = 1;
                }
                // 记住使用的缩放值
                this.displacement.scale = newScale;
                // 图像应用缩放效果
                // console.log(newScale);
                this.matrixBox.style.transform = "scale(" + newScale + ")";
                // 设置旋转元素的基点位置
                // matrixBox.style.transformOrigin = "0px 0px 0px";
            }else {
                let movePageX = events.pageX - this.displacement.pageX;
                let movePageY = events.pageY - this.displacement.pageY;
                this.matrixBox.style.top = `${this.top + movePageY}px`
                this.matrixBox.style.left = `${this.left + movePageX}px`
            }
        },

        end(event) {
            this.top = Number(this.matrixBox.style.top.replace('px', ''));
            this.left = Number(this.matrixBox.style.left.replace('px', ''));
        },

        getDistance(start, stop) {
            // Math.hypot()计算参数的平方根
            return Math.hypot(stop.x - start.x, stop.y - start.y);
        },
    }
}
</script>

<style lang="scss" scoped>
.image-zoom {
    position: relative;

    img {
        object-fit: contain;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/zoom.vue